import { Box, NotFound, Text } from '@factorialco/deprecated-design-system'
import { isEmptyDocument } from 'datocms-structured-text-utils'
import { ItemIntegrationFragment } from 'generated/resources/graphql'

import i18n from 'modules/core/lib/i18n'

import { SetupInformation } from 'modules/marketplace/components/Description/SetupInformation'
import { IntegrationAside } from 'modules/marketplace/components/Item/IntegrationAside'

type SetupProps = {
  integration: ItemIntegrationFragment
}

const ExternalIntegrations = ({ integration }: SetupProps) => {
  const parsedSetupInformation = integration.setupInformation
    ? JSON.parse(integration.setupInformation)
    : null
  const hasIntegrationSetupInformation = !isEmptyDocument(parsedSetupInformation)

  if (!hasIntegrationSetupInformation)
    return (
      <NotFound
        title={`${integration.name} ${i18n.t('marketplace.integrations.setup')}`}
        description={i18n.t('marketplace.integrations.setup_error_description')}
      />
    )

  return (
    <Box flexDirection="column" gap="s12">
      <Box width="full" flexDirection="row" alignItems="center" gap="s12">
        <Box flexDirection="row" alignItems="center" gap="s12">
          {integration?.logo?.url && <img width="64px" src={integration.logo.url} />}
        </Box>
        <Text.Header1 weight="medium">
          {integration.name} {i18n.t('marketplace.integrations.setup')}
        </Text.Header1>
      </Box>

      <Box
        style={{ display: 'grid', gridTemplateColumns: '1fr auto', gap: 's32' }}
        paddingTop="s32"
      >
        <SetupInformation id="2" data={integration.setupInformation || ''} />
        <IntegrationAside integration={integration} />
      </Box>
    </Box>
  )
}

export default ExternalIntegrations
